<template>
  <div style="height: 100vh;background-color: #e6f7ff;">
    <a-spin tip="Loading..." style="position: absolute; top: 50%; transform: translateY(-50%); left: 50%;transform: translateX(-50%)">
    </a-spin>
  </div>
</template>

<script>
export default {
  name: 'ddfp',
  mounted () {
    const userAgent = navigator.userAgent
    // // 判断是否在 PC 端钉钉
    let isPcDingTalk = /DingTalk/i.test(userAgent) && /Windows/i.test(userAgent)
    // // 判断是否在手机移动端钉钉
    let isMobileDingTalk = /DingTalk/i.test(userAgent) && /Mobile/i.test(userAgent)
    if (isPcDingTalk) {
      this.$router.push({path: '/ddLogin', query: {procInsId: this.$route.query.procInsId, taskId: this.$route.query.taskId}})
    }
    if (isMobileDingTalk) {
      // eslint-disable-next-line no-undef
      window.location.replace(`${GlobUrl.fpMobileUrl}?instanceId=${this.$route.query.procInsId}&taskId=${this.$route.query.taskId}`)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/ddLogin/ddfp.vue